import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';

/**
 * Use v-menu-toggle to control site menu's visiblity
 */
export const menuToggle = {
  mounted(el) {
    const siteMenu = document.querySelector('.js-site-menu');
    const siteMenuBackground = document.querySelector('.js-site-menu-background');
    const siteMenuButton = el;
    const siteHeader = document.querySelector('.js-header');

    siteMenuButton.addEventListener('click', () => {
      const isMenuActive = siteMenu.classList.toggle('is-active');
      siteMenuBackground.classList.toggle('is-active');
      siteHeader.classList.toggle('is-menu-active');

      const isHeaderAwayFromTop = siteHeader.getBoundingClientRect().top > 0;
      if (isHeaderAwayFromTop) {
        siteHeader.scrollIntoView({ behavior: 'smooth' });
      }

      siteMenu.dispatchEvent(new CustomEvent('menustatechange', { detail: { isMenuActive } }));
    });

    siteMenu.addEventListener('menustatechange', ({ detail }) => {
      siteMenuButton.ariaExpanded = detail.isMenuActive.toString();

      if (detail.isMenuActive) {
        disableBodyScroll(siteMenu, { reserveScrollBarGap: true });
      } else {
        clearAllBodyScrollLocks();
      }

      if (detail.isMenuActive) {
        siteMenuButton.classList.add('is-active');
      } else {
        siteMenuButton.classList.remove('is-active');
      }
    });
  },
};
